import { InfoIcon } from '~/@mid_ui/icons/InfoIcon'
import { HeadingThree } from '~/@mid_ui/typography/HeadingThree'
import { Text } from '~/@mid_ui/typography/Text'

function ResetInfo() {
  return (
    <div className="flex flex-col justify-center items-start max-w-400 gap-8 px-20">
      <HeadingThree className="text-2xl text-primary-foreground">
        Nastavenie nového hesla
      </HeadingThree>
      <div className="flex flex-col gap-6">
        <div className="flex flex-row items-start text-primary-foreground">
          <InfoIcon className="mr-2 size-6" />
          <Text className="text-primary-foreground">
            Zadajte nové heslo a potvrďte ho ešte raz
          </Text>
        </div>
      </div>
    </div>
  )
}

export { ResetInfo }
